function Notice() {
    return (
        <section className="notice font-jap">
            <div className="container">
                <div className="notice__con">
                    <p> 期間限定トライアルセット販売中✨</p>
                    <p>詳細はこちら→</p>
                </div>
            </div>
        </section>
    )
}

export  default  Notice
